import {GesamtabfrageDownloadFile, GesamtabfrageDownloadStrategy} from "./gesamtabfrage-download-strategy";
import {inject, Injectable} from "@angular/core";
import {Store} from "@softline/core";
import {SOFTLINE_API_DOWNLOAD_VOLUME} from "../../gesamtabfrage.api";
import { Beleg, Belegart } from '@softapps/wws/gesamtabfrage/api';

@Injectable()
export class DatentraegerDownloadStrategy implements GesamtabfrageDownloadStrategy {
  type = 'ebinvoice';
  icon = 'fa-regular fa-database';
  label = '#GESAMTABFRAGE.ACTIONS.DOWNLOAD_DATENTRÄGERDATEI';

  private store = inject(Store);

  async getDownloadFiles(belege: Beleg[], belegart: Belegart): Promise<GesamtabfrageDownloadFile[]> {
    const files: GesamtabfrageDownloadFile[] = [];

    for (const beleg of belege)
      files.push({
        filename: `${belegart.id}_${beleg.bezugsnummer ?? beleg.belegnummer}_ebinvoice.xml`,
        location: {path: SOFTLINE_API_DOWNLOAD_VOLUME},
        body: { ids: [beleg.id], zusammenfassen: false, belegart, fremdbelegdruck: false },
      });

    return files;
  }
}
